import $ from "jquery";
import "slick-carousel";

$(document).ready(function() {
    var fullWidthImageSlider = $(".slider__image-repeater");

    $(".slider__image-repeater").each(function(i){
        let numberOfImages = $(this).find('.slider__image-repeater__image').length;
        let imageSliderInstance = [];

        imageSliderInstance[i] = $(this).slick({
            adaptiveHeight: false,
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 4,
            arrows: false,
            dots: false,
            autoplay: false,
            pauseOnHover: false,
            centerMode: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        // slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        // slidesToScroll: 1,
                    }
                },
            ]
        });


        if (numberOfImages < fullWidthImageSlider.slick('slickGetOption','slidesToShow')) {
            $(this).siblings('.slider-controls').hide();
        }

        $(".arrow--right").click(function () {
            imageSliderInstance[i].slick("slickNext");
        });

        $(".arrow--left").click(function () {
            imageSliderInstance[i].slick("slickPrev");
        });

    });

    var fullWidthCardSlider = $(".slider__cards");

    $(".slider__cards").each(function(i){
        let numberOfCards = $(this).find('.slider__cards--card').length;
        let cardSliderInstance = [];
        let slidesPerPageDesktop = $(this).attr('data-slides-per-page-desktop');
        let slidesPerPageTablet = $(this).attr('data-slides-per-page-tablet');
        let slidesPerPageMobile = $(this).attr('data-slides-per-page-mobile');

        cardSliderInstance[i] = $(this).slick({
            adaptiveHeight: false,
            infinite: true,
            slidesToShow: slidesPerPageDesktop,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            autoplay: false,
            pauseOnHover: false,
            centerMode: true,
            centerPadding: 0,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: slidesPerPageTablet,
                        // slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: slidesPerPageMobile,
                        // slidesToScroll: 1,
                    }
                },
            ]
        });

        if (numberOfCards <= fullWidthCardSlider.slick('slickGetOption','slidesToShow')) {
            $(this).parent().find('.slider-controls').hide();
        }

        $(".arrow--right").click(function () {
            cardSliderInstance[i].slick("slickNext");
        });

        $(".arrow--left").click(function () {
            cardSliderInstance[i].slick("slickPrev");
        });

    });
});